export default __webpack_public_path__ + "static/error-number-500-39fc04a92519efb7f34170c85ac324ce.svg";